import OliverText from "@builder/components/general/OliverText";
import SimpleCheckbox from "@builder/components/general/SimpleCheckbox";
import TextInput from "@builder/components/general/TextInput";
import { ActionEditorItem, updateStepperActions } from "@builder/store/slices/actionBuilderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { ActionType } from "@common/build/types";
import { useEffect, useState } from "react";

const AddCartNote = () => {
    const { id } = useAppSelector(state => state.actionBuilder.current);
    const actionStep = useAppSelector(state => state.actionBuilder.actionsEditor.find(item => item.id === id));
    const [isFixed, setFixed] = useState(actionStep?.action?.data.isFixed || false);
    const [note, setNote] = useState<string>(actionStep?.action?.data.note || "");
    const dispatch = useAppDispatch();

    useEffect(() => {
        const action = { type: isFixed ? ActionType.CART_ADD_NOTE : ActionType.SHOW_ORDER_NOTE_UI, data: { isFixed, note: isFixed ? note : "" } };
        const updatedStep = { ...actionStep };
        updatedStep.action = { ...action };

        if (JSON.stringify(updatedStep) !== JSON.stringify(actionStep)) {
            dispatch(updateStepperActions({ id: id, item: updatedStep as ActionEditorItem}));
        }
    }, [actionStep, dispatch, id, isFixed, note]);

    return (
        <div className="function-add-cart-note-wrapper">
            <OliverText text="How do you want to add the note?" size="xs" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
            <div className="function-add-cart-note">
                <div className="function-checkbox-wrapper" onClick={() => setFixed(false)}>
                    <div className="function-checkbox-label-wrapper">
                        <OliverText text="Open note input box" size="xs" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
                        <OliverText text="This will open the note pop up" size="xs" weight="light" translatePrefix="popup.actionBuilder." />
                    </div>
                    <SimpleCheckbox callback={() => {}} checked={!isFixed} label="" value="" custom={false} />
                </div>
                <div className="function-checkbox-wrapper" onClick={() => setFixed(true)}>
                    <div className="function-checkbox-label-wrapper">
                        <OliverText text="Fixed message" size="xs" weight="medium-heavy" translatePrefix="popup.actionBuilder." />
                        <OliverText text="This will automatically add a fixed message" size="xs" weight="light" translatePrefix="popup.actionBuilder." />
                    </div>
                    <SimpleCheckbox callback={() => {}} checked={isFixed} label="" value="" custom={false} />
                </div>
                {isFixed ? (
                    <TextInput callback={setNote} value={note} className="actions-tab-input" placeholder="Input message" />
                ) : null}
            </div>
        </div>
    );
};

export default AddCartNote;
